module.exports = __webpack_public_path__ + "band_3.efafbe31.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/child_to_parent/band_3.png
// module id = KMBa
// module chunks = 0